import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=ad72291e&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad72291e')) {
      api.createRecord('ad72291e', component.options)
    } else {
      api.reload('ad72291e', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=ad72291e&", function () {
      api.rerender('ad72291e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O4573992EJmS/JS/comp/starrating.vue"
export default component.exports